// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
} from '@mui/x-data-grid';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {
    Drawer,
    Stack,
} from "@mui/material";
import Typography from "@mui/material/Typography";

// App Imports
import {getViewershipObligationData} from "../../../ExternalData/Viewership/ViewershipClient";
import {changeObligationHierarchy} from "../obligationHierarchySlice";


// main function
export default function WorkIssuanceObligationViewershipGrid() {


    // ****************** BEGIN STATES ****************************

    const [viewershipData, setViewershipData] = useState([]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCdpvId = useSelector((state) => state.obligationHierarchySlc.value.cdpvId);
    const selectorDataPointName = useSelector((state) => state.obligationHierarchySlc.value.dataPointName);
    const selectorDisplayAmount = useSelector((state) => state.obligationHierarchySlc.value.displayValue);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchViewershipData = () =>
        getViewershipObligationData(selectorCdpvId)

            .then(data => {
                console.log(data);
                // setDrilldownCDPVF(data);
                setViewershipData(data);
                console.log("This is my data used for the grid rows...");
                console.log(viewershipData);
            })

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("My viewership grid should have displayed...");
        fetchViewershipData();
    }, [useSelector((state) => state.obligationHierarchySlc.value.viewershipGridOpen)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClose = () => {
        dispatchData(changeObligationHierarchy({viewershipGridOpen: false}));
    };


    function closeViewershipDataDrawer() {
        dispatchData(changeObligationHierarchy({viewershipGridOpen: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchViewershipData => [
        {    field: 'id',
            headerName: 'Id',
            description: '',
            sortable: false,
            width: 50,
            hide: false,
        },
        {    field: 'viewDate',
            headerName: 'Date',
            description: '',
            sortable: false,
            width: 150,
            hide: false,
        },
        {    field: 'views',
            headerName: 'Views',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },
        {    field: 'viewedMinutes',
            headerName: 'Viewed Minutes',
            description: '',
            sortable: false,
            width: 150,
            hide: false,
        },
        {    field: 'rating',
            headerName: 'Rating',
            description: '',
            sortable: false,
            width: 60,
            hide: false,
        },
        {    field: 'source',
            headerName: 'Source',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },

        {    field: 'platformName',
            headerName: 'Platform',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'service',
            headerName: 'Service',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'platformTerritory',
            headerName: 'Territory',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },
        {    field: 'externalId',
            headerName: 'External ID',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },

    ];

    // *************** END COLUMNS *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarDensitySelector />
                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer sx={{height: "100%", width: 1600}}
                    anchor='right'
                    open={useSelector((state) => state.obligationHierarchySlc.value.viewershipGridOpen)}
                    onClose={closeViewershipDataDrawer}
            >
                <Box>
                    <br/>
                    <h2 style={{paddingLeft: 19, cursor: 'pointer'}} onClick={() => handleClose()}>Viewership Data</h2>
                    <br/>
                    < Stack direction="row" spacing={2}>
                        <Typography sx={{fontWeight: 'bold', pl: 3}}>Data Point</Typography>
                        <Typography>{selectorDataPointName}: {selectorDisplayAmount}</Typography>
                    </Stack>
                    <Box sx={{pl: 2}}>
                        <DataGridPro
                            style={{height: 600, width: 1000}}
                            aria-label={"ViewershipDataDrawerGrid"}
                            rows={viewershipData}
                            disableDensitySelector={true}
                            disableColumnSelector={true}
                            columns={columns(fetchViewershipData)}
                            density={"compact"}
                            pageSize={20}
                            rowsPerPageOptions={[20]}
                            rowThreshold={0}
                            components={{
                                Toolbar: CustomToolbar,
                            }}
                        />
                    </Box>
                </Box>
            </Drawer>
        </div>
);

    // ****************** END RETURN ****************************


}



